module.exports = __webpack_public_path__ + "static/media/20ECE32.a93d8b24.jpg";